import { render } from "./TargetContainer.vue?vue&type=template&id=e983deb6&scoped=true&ts=true"
import script from "./TargetContainer.vue?vue&type=script&lang=ts"
export * from "./TargetContainer.vue?vue&type=script&lang=ts"

import "./TargetContainer.vue?vue&type=style&index=0&id=e983deb6&scoped=true&lang=css"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e983deb6"]])

export default __exports__